import { ZuersZone } from "@/model/ZuersZone";
import { Zahlungsdaten } from "@/model/Zahlungsdaten";
import { Vorversicherung } from "@/model/Vorversicherung";
import { Vorschaden } from "@/model/Vorschaden";
import { Tarifinformationen } from "@/model/Tarifinformationen";
import { Preise } from "@/model/Preise";
import { ModulPreis } from "@/model/ModulPreis";
import { Personendaten } from "@/model/Personendaten";
import { Korrespondenz } from "@/model/Korrespondenz";
import { Adresse } from "@/model/Adresse";
import { Gebaeudedaten } from "@/model/Gebaeudedaten";
import { Ferienhaus } from "@/model/Ferienhaus";
import { Datei } from "@/model/Datei";
import { BuendelStatus } from "@/model/BuendelStatus";
import { Aussteuerung } from "@/model/Aussteuerung";
import { BuendelAussteuerung } from "@/model/BuendelAussteuerung";
import { Outbound } from "@/model/Outbound";

export enum Status {
  NEU = "NEU",
  ERSTELLT = "ERSTELLT",
  UEBERMITTELT = "UEBERMITTELT",
  ABGELEHNT = "ABGELEHNT",
  UNGUELTIG = "UNGUELTIG",
}

export class Anfrage {
  id = "";
  anfrageNummer = 0;
  vermittlerNummer = "";
  status = Status.NEU;
  buendelStatusListe: BuendelStatus[];
  subStatus = "";
  typ = "";
  aktion = "";
  isMakler = false;
  isMaklerLink = false;
  verkaufsprodukt = "";
  isDunkelverarbeitung = false;
  nurSanierungAusgesteuert = false;
  fahrradErsterAufruf = false;
  adresseFelderSchrittDreiDeaktivieren = false;
  bauleitungDurchDritte = false;
  antragssteller = "";
  erstelldatum = "";
  updatedatum = "";
  korrespondenz = new Korrespondenz();
  personendaten = new Personendaten();
  gebaeudedaten = new Gebaeudedaten();
  tarifinformationen = new Tarifinformationen();
  zahlungsdaten = new Zahlungsdaten();
  vorversicherung = new Vorversicherung();
  vorschaeden: Vorschaden[];
  risikoAnschrift = new Adresse();
  preise = new Preise();
  modulPreise: ModulPreis[];
  aussteuerung: Aussteuerung[];
  buendelAussteuerungListe: BuendelAussteuerung[];
  zuersZone = new ZuersZone();
  ferienhaus = new Ferienhaus();
  gebaeudeRisikoIndex = "";
  tarifOptionenZuVerbergen: string[];
  vorbelegungsId = ""; // ID der Vorbelegung bei Vertragsneuordnung im Maklerportal
  vertriebsProduktlinie = "";
  werbeeinwilligung = "";
  datenschutzhinweiseAkzeptiert = false;
  erinnerungsEmail1Gesendet = "";
  erinnerungsEmail2Gesendet = "";
  emailVersandFehler = "";
  vorschlagDokumentVorhanden = false;
  abTest = "";
  produktName = "";
  externeReferenz = "";
  dateien: Datei[];

  //Frontend-spezifische Erweiterungen
  sessionId = "";
  plzValidiert = true;
  neuberechnen = false;
  trackingSeitenkontext = "";
  antragId: string | undefined;
  sanierungAusgesteuert = false;
  gewerbeArtAusgesteuert = false;
  anschriftAusgesteuert = false;
  baujahrAusgesteuert = false;
  leerstandAusgesteuert = false;
  denkmalschutzAusgesteuert = false;

  berechnungDurchgefuehrt = false;
  vhvElementarAusblenden = true;
  affiliate = "";
  loading = false;
  outbound = new Outbound();

  constructor() {
    this.buendelStatusListe = [];
    this.vorschaeden = [
      new Vorschaden(),
      new Vorschaden(),
      new Vorschaden(),
      new Vorschaden(),
      new Vorschaden(),
    ];
    this.modulPreise = [new ModulPreis()];
    this.aussteuerung = [];
    this.buendelAussteuerungListe = [];
    this.tarifOptionenZuVerbergen = [];
    this.dateien = [];
    this.antragId = undefined;
  }
}
